'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));

var mailStamp = 'M26.56,32.67h-7a.93.93,0,0,0-.93.93v6.71a.93.93,0,0,0,.93.92h7a.93.93,0,0,0,.93-.92V33.6A.93.93,0,0,0,26.56,32.67Zm-.07,7.56h-6.9V33.67h6.9Z';

var mailText1 = 'M22.75,35.65h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,22.75,35.65Z';

var mailText2 = 'M25.34,37.35h-4.6a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h4.6a.5.5,0,0,1,.5.5A.5.5,0,0,1,25.34,37.35Z';

var mailText3 = 'M25.34,39.08h-4.6a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h4.6a.5.5,0,0,1,.5.5A.5.5,0,0,1,25.34,39.08Z';

var mailOutline = 'M47.77,25.09l-5-9.87a1,1,0,0,0-.86-.53H35l1.21,10.41h0V29.3a.71.71,0,0,1-.73.69H29a.71.71,0,0,1-.73-.69V25.09h0l1.21-10.42H22.29a1,1,0,0,0-.85.51l-5,9.9V47.53a1.22,1.22,0,0,0,1.21,1.22H28.27V44.26a.74.74,0,0,1,.73-.74h6.49a.73.73,0,0,1,.73.74v4.49H46.56a1.22,1.22,0,0,0,1.21-1.22ZM27,40.31a.43.43,0,0,1-.43.42h-7a.42.42,0,0,1-.43-.42V33.6a.43.43,0,0,1,.43-.43h7a.44.44,0,0,1,.43.43Z';

var mailBody = 'M48.22,24.86l-5-9.87a1.44,1.44,0,0,0-1.3-.8H22.28A1.46,1.46,0,0,0,21,15l-5,9.89a.46.46,0,0,0-.05.23V47.53a1.71,1.71,0,0,0,1.71,1.72H46.56a1.72,1.72,0,0,0,1.71-1.72V25.09A.59.59,0,0,0,48.22,24.86Zm-6.3-9.67a.45.45,0,0,1,.41.25L47,24.59H36.67l-1.1-9.41Zm-7.25.94,1,8.46H28.83l1.1-9.42h4.63Zm1,9.46V29.3a.21.21,0,0,1-.23.19H29a.21.21,0,0,1-.23-.19V25.59ZM21.89,15.42a.44.44,0,0,1,.4-.24h6.63l-1.09,9.42H17.29ZM35.72,48.25H28.77v-4a.23.23,0,0,1,.23-.24h6.5a.23.23,0,0,1,.22.24Zm11.55-.72a.71.71,0,0,1-.71.72H36.72v-4h0v0A1.23,1.23,0,0,0,35.49,43H29a1.23,1.23,0,0,0-1.23,1.24v4H17.69a.71.71,0,0,1-.71-.72V25.59H27.77V29.3A1.21,1.21,0,0,0,29,30.49h6.49a1.21,1.21,0,0,0,1.23-1.19V25.59H47.27Z';

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var _templateObject = taggedTemplateLiteral(['\n  width: ', ';\n  height: ', ';\n  vertical-align: ', ';\n'], ['\n  width: ', ';\n  height: ', ';\n  vertical-align: ', ';\n']);

var Svg = styled.svg(_templateObject, function (props) {
  return props.s.width || '4rem';
}, function (props) {
  return props.s.height || 'auto';
}, function (props) {
  return props.s.verticalAlign || 'middle';
});

var MailIcon = function MailIcon(_ref) {
  var s = _ref.s,
      className = _ref.className,
      outlineColor = _ref.outlineColor,
      fillColor = _ref.fillColor;
  return React.createElement(
    Svg,
    { s: s, className: className, viewBox: '0 0 64 64' },
    React.createElement(
      'g',
      null,
      React.createElement('path', { fill: fillColor, d: mailOutline }),
      React.createElement('path', { fill: outlineColor, d: mailText1 }),
      React.createElement('path', { fill: outlineColor, d: mailText2 }),
      React.createElement('path', { fill: outlineColor, d: mailText3 }),
      React.createElement('path', { fill: outlineColor, d: mailBody }),
      React.createElement('path', { fill: outlineColor, d: mailStamp })
    )
  );
};

MailIcon.defaultProps = {
  className: null,
  s: {},
  outlineColor: '#231f20',
  fillColor: '#e8e8e8'
};

MailIcon.propTypes = {
  className: PropTypes.string,
  outlineColor: PropTypes.string,
  fillColor: PropTypes.string,
  s: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string,
    verticalAlign: PropTypes.string
  })
};

exports.default = MailIcon;
//# sourceMappingURL=index.js.map
